var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordHiddenDarkgrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8081)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8081",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 41.3959C19.7467 41.4055 14.6178 39.7973 10.3104 36.79C6.09802 33.8632 2.84945 29.7515 0.976562 24.9763C2.84963 20.2015 6.0982 16.0905 10.3104 13.1642C14.6223 10.1657 19.7485 8.55859 25.0004 8.55859C30.2523 8.55859 35.3785 10.1657 39.6903 13.1642C43.9022 16.0906 47.1505 20.2017 49.0234 24.9763C47.1508 29.7514 43.9025 33.8631 39.6903 36.79C35.3827 39.7975 30.2536 41.4056 25 41.3959ZM25 14.0318C18.9793 14.0318 14.0812 18.9415 14.0812 24.9763C14.0812 31.011 18.9793 35.9226 25 35.9226C31.0207 35.9226 35.9208 31.0121 35.9208 24.9763C35.9208 18.9404 31.0218 14.0318 25 14.0318ZM25 31.5449C23.7005 31.5478 22.4293 31.165 21.3474 30.4451C20.2655 29.7252 19.4214 28.7005 18.9221 27.5008C18.4228 26.301 18.2906 24.9801 18.5423 23.7051C18.7941 22.4302 19.4183 21.2586 20.3362 20.3386C21.254 19.4187 22.4241 18.7916 23.6985 18.5369C24.9728 18.2823 26.294 18.4113 27.495 18.9079C28.6959 19.4044 29.7226 20.246 30.445 21.3262C31.1674 22.4065 31.5531 23.6767 31.5533 24.9763C31.5537 26.7158 30.8638 28.3845 29.6352 29.616C28.4066 30.8475 26.7396 31.5412 25 31.5449Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96738 47.6024L6.08203 46.0514L42.036 2.34961L43.9214 3.90078L7.96738 47.6024Z",
    fill: "#707070"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHiddenDarkgrey);
export default __webpack_public_path__ + "static/media/password_hidden_darkgrey.3f3960c74a7c59d8e3fcbe2ebbaaeb9a.svg";
export { ForwardRef as ReactComponent };